import { useEffect, useState, useCallback } from 'react';
import axios from '../../api/axiosInstance';

function useUserReservations(userId) {
  const [userReservations, setUserReservations] = useState([]);
  const [userReservedDates, setUserReservedDates] = useState([]);
  const [isLoadingReservations, setIsLoadingReservations] = useState(true);

  const HOST = process.env.REACT_APP_HOST;
  const PORT = process.env.REACT_APP_API_PORT;
  const baseUrl = `https://${HOST}`;

  const fetchReservations = useCallback(() => {
    if (userId === null) return;

    const token = localStorage.getItem('token');
    setIsLoadingReservations(true);

    axios.get(`${baseUrl}/api/user/reservations`)
      .then((res) => {
        const reservations = res.data;
        const reservedDates = reservations.map(r => r.date);
        setUserReservations(reservations);
        setUserReservedDates(reservedDates);
      })
      .catch(() => {
        setUserReservations([]);
        setUserReservedDates([]);
      })
      .finally(() => {
        setIsLoadingReservations(false);
      });
  }, [userId, baseUrl]);

  useEffect(() => {
    fetchReservations();
  }, [fetchReservations]);

  return {
    userReservations,
    userReservedDates,
    isLoadingReservations,
    refetchUserReservations: fetchReservations,
  };
}

export default useUserReservations;
